import Form, { FormProps } from "@/shared/form/form";
import { FieldsType } from "../model/types";
import Input from "@/shared/form/input";
import { LocalizedValue } from "@/shared/form/localized-value";
import InputNumber from "@/shared/form/input-number";
import { SubmitButton, SubmitWrapper } from "@/shared/form/button";
import { useTranslations } from "use-intl";
import { EnumSelect } from "@/modules/dynamic-attributes/entities/enum-select";
import { ChangingAttributeCodeHint } from "../../save-simple-dynamic-attribute/ui/hints";

export function EnumDynamicAttributeForm(props: FormProps<FieldsType>) {
  const t = useTranslations("DynamicAttributes");

  return (
    <Form layout="vertical" {...props}>
      <Form.Item<FieldsType> name="id" hidden>
        <Input />
      </Form.Item>

      <LocalizedValue
        name="name"
        label={t("Name")}
        render={({ placeholder }) => <Input placeholder={placeholder} />}
        myLocaleRules={[{ required: true }]}
      />

      <LocalizedValue
        name="description"
        label={t("Description")}
        render={({ placeholder }) => (
          <Input.TextArea placeholder={placeholder} />
        )}
      />

      <Form.Item<FieldsType> name="order" label={t("Order")}>
        <InputNumber />
      </Form.Item>

      <Form.Item<FieldsType> name="group" hidden>
        <Input />
      </Form.Item>

      <Form.Item<FieldsType> name="dynamicAttributeEntity" hidden>
        <Input />
      </Form.Item>

      <Form.Item<FieldsType>
        name="attributeCode"
        label={t("Attribute code")}
        extra={<ChangingAttributeCodeHint />}
        rules={[{ required: true }]}
      >
        <Input />
      </Form.Item>

      <Form.Item<FieldsType>
        name="enum"
        label={t("Enum")}
        extra={<ChangingAttributeCodeHint />}
        rules={[{ required: true }]}
      >
        <EnumSelect />
      </Form.Item>

      <Form.Item<FieldsType> name="category" hidden>
        <Input />
      </Form.Item>

      <SubmitWrapper>
        <SubmitButton />
      </SubmitWrapper>
    </Form>
  );
}
